'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('../Alert/Alert.js');
require('../Article/Article.js');
require('../ArticleInfoBlock/ArticleInfoBlock.js');
require('../Banner/Banner.js');
require('../BreadCrumbs/BreadCrumbs.js');
require('../ErrorPage/ErrorPage.js');
require('../FeatureCarousel/FeatureCarousel.js');
require('../FeatureCarousel/FeaturedCarouselItem/FeaturedCarouselItem.js');
require('../FeaturedMarquee/FeaturedMarquee.js');
require('../OpenPositions/OpenPositions.js');
require('../OurTeam/OurTeam.js');
require('../PageHeader/PageHeader.js');
require('../Pagination/Pagination.js');
require('../PaginationContainer/PaginationContainer.js');
require('../PanelGroup/PanelGroup.js');
require('../PanelGroup/Panel/Panel.js');
require('../PodcastCarousel/PodcastCarousel.js');
require('../SecondaryNav/SecondaryNav.js');
var Section = require('../Section/Section.js');
require('../Section/SectionHeader/SectionHeader.js');
require('../SplitBanner/SplitBanner.js');
require('../SplitBanner/SplitBannerImage/SplitBannerImage.js');
require('../SplitBanner/SplitBannerVideo/SplitBannerVideo.js');
require('../SplitBanner/SplitBannerContent/SplitBannerContent.js');
require('../SplitBanner/SplitBannerContact/SplitBannerContact.js');
var Button = require('../../primitives/Button/Button.js');
var PropTypes = require('prop-types');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var NewsletterSubscription = function NewsletterSubscription(_ref) {
  var backgroundColor = _ref.backgroundColor;
  return /*#__PURE__*/React__default.default.createElement(Section.Section, {
    backgroundColor: backgroundColor,
    className: "newsletter-subscription"
  }, /*#__PURE__*/React__default.default.createElement("h4", {
    className: "newsletter-subscription-title"
  }, "Subscribe to our Newsletter"), /*#__PURE__*/React__default.default.createElement("p", {
    className: "newsletter-subscription-description"
  }, "Sign up to receive the latest news and feature stories from Los Alamos National Laboratory"), /*#__PURE__*/React__default.default.createElement("div", {
    className: "newsletter-subscription-controls"
  }, /*#__PURE__*/React__default.default.createElement("input", {
    type: "text",
    placeholder: "Email address",
    className: "newsletter-subscription-input"
  }), /*#__PURE__*/React__default.default.createElement(Button.Button, {
    className: "newsletter-subscription-button",
    onClick: function onClick() {
      window.location.replace('https://service.govdelivery.com/accounts/USLANL/subscriber/new?category_id=USLANL_C7');
    }
  }, "SIGN UP")));
};
NewsletterSubscription.defaultProps = {
  backgroundColor: '#F1EFF7'
};
NewsletterSubscription.propTypes = {
  backgroundColor: PropTypes__default.default.string
};

exports.NewsletterSubscription = NewsletterSubscription;
exports.default = NewsletterSubscription;
//# sourceMappingURL=NewsletterSubscription.js.map
